<template>
  <footer class="brand-bgcolor">
    <div class="footer-wrap">
      <div class="container mb-3">
        <div class="abbv-blk">
          <span v-html="$t('Footer.legalrules')">            
          </span>
        </div>
      </div>
      <div class="footer-bar">
        <img src="https://snippcheck.blob.core.windows.net/files/kelloggs-feeding-reading-2007630/footer-bar.png"
          alt="" class="img-fluid" width="100%">
      </div>
      <div class="container-fluid">
      <div class="navbar">
        <div class="col-sm-12 p-0 text-center">
      <ul class="list-inline mb-0" id="footer-nav">      
        <li class="list-inline-item" v-html="$t('Footer.T&CLink')">   
        </li>
        <li class="list-inline-item" v-html="$t('Footer.PrivayPolicyLink')">   
        </li>
        <li class="list-inline-item" v-html="$t('Footer.TermsOfUseLink')">   
        </li>
        <li class="list-inline-item" v-html="$t('Footer.CookiePreference')">              
        </li>
        <li class="list-inline-item" v-html="$t('Footer.AccessibilityLink')">   
        </li>
        <li class="list-inline-item" v-html="$t('Footer.FAQlink')">   
        </li>
        <li class="list-inline-item" v-html="$t('Footer.ContactUsLink')">   
        </li>        
      </ul>
      <p class="mt-3">
        <small
          >{{$t('Footer.copyrighttext')}} © {{ new Date().getFullYear() }} {{$t('Footer.AllrightReserved')}}</small
        >
      </p>

    </div> 
  </div>
  </div>
    <!-- <div class="footer-right ">
      <div class="footer-social-nav">
        <ul class="list-inline m-0">
          <li>
            <a
              href="#"
              class="fb-link social-icon"
              title="facebook"
              target="_blank"
            >
              <i class="fab fa-facebook-square"></i>
            </a>
          </li>
          <li>
            <a
              href="#"
              class="twitter-link social-icon"
              title="twitter"
              target="_blank"
            >
              <i class="fab fa-square-x-twitter"></i>
            </a>
          </li>
          <li>
            <a
              href="#"
              class="ig-link social-icon"
              title="instagram"
              target="_blank"
            >
              <i class="fab fa-instagram-square"></i>
            </a>
          </li>
          <li>
            <a
              href="#"
              class="yt-link social-icon"
              title="youtube"
              target="_blank"
            >
              <i class="fab fa-youtube-square"></i>
            </a>
          </li>
        </ul>
      </div>
     
    </div> -->
    </div>
  </footer>
</template>

<script>
//Younet chatbot code apprended in the body
export default {
  mounted() {
    // // Dynamically fetch the translated modelHash
    // const modelHash = this.$t('YounetmodelHash');
    // const modelImgurl = this.$t('YounetmodelIMg');
    // const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}`;

    // // Dynamically create the script element
    // const script = document.createElement('script');
    // script.type = 'module';
    // script.src = scriptUrl;

    // // Append the script to the body
    // document.body.appendChild(script);
  },
};
</script>
<style scoped>
footer {
  color: #fff;
  margin-top: auto;
  font-size: 16px;
}

.footer-wrap {
  background-color: #513629;
  padding: 3rem 0;
  position: relative;
}

.footer-wrap:before {
  content: "";
  background-image: url('https://snippcheck.blob.core.windows.net/files/kelloggs-feeding-reading-2007630/footer-top.png');
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background-size: 100%;
  background-repeat: no-repeat;
}


#footer-nav li+li:before {
  content: ' | ';
  color: #fff;
  margin-right: 7px;
}

.footer-social-nav .social-icon {
  color: #fff;
  font-size: 2rem;
  border-radius: 5px;
}

.footer-social-nav {
  float: right;
}

.footer-social-nav .social-icon:hover {
  color: #176198;
}

.list-inline>li {
  display: inline-block;
  padding-left: 5px;
  padding-right: 5px;
}

a {
  font: inherit;
  background: transparent;
  border: 1px solid transparent;
  cursor: pointer;
  color: white;
  margin: 5px 0;
  display: inline-block;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
.abbv-blk {
    color: #a8a8a8;
}
@media screen and (max-width: 575px) {
  .navbar {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #footer-nav li+li:before {
    content: '';
    margin-right: 0px;
  }

  footer {
    text-align: center;
  }

  footer li.list-inline-item {
    display: block;
  }

  footer li.list-inline-item {
    display: block;
  }

  .footer-social-nav {
    float: none;
  }
}
</style>


